import React from 'react';
import { Link } from 'react-router-dom';

export default function PrivacyPolicy() {
  return (
    <div className="max-w-4xl mx-auto px-6 py-12 text-gray-800">
      <Link to="/" className="text-cyan-500 underline mb-6 inline-block">← Back to Home</Link>
      <h1 className="text-3xl font-bold mb-4">Privacy Policy</h1>
      <p className="mb-4">
        At V Adithya Pvt. Ltd., your privacy is our priority. We are committed to safeguarding your personal information and ensuring transparency in how we handle it.
      </p>
      <p className="mb-4">
        We collect personal data such as name, email, phone number, location, and job preferences for the sole purpose of recruitment and communication. We do not share this information with third parties without your consent.
      </p>
      <p className="mb-4">
        By submitting forms on our site, you consent to this policy. If you have questions, please contact us at <a href="mailto:support@adithyainfinity.com" className="text-cyan-500">support@adithyainfinity.com</a>.
      </p>
    </div>
  );
}
